import { cn } from '@/core/utils/cn';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  hover?: boolean;
  id?: string;
}

const paddingStyles = {
  none: '',
  sm: 'p-3 sm:p-4',
  md: 'p-4 sm:p-6',
  lg: 'p-5 sm:p-8',
};

export function Card({ children, className, padding = 'md', hover, id }: CardProps) {
  return (
    <div id={id} className={cn(
      'bg-hms-card border border-hms-border rounded-xl',
      paddingStyles[padding],
      hover && 'hover:border-hms-textDim/30 transition-colors cursor-pointer',
      className
    )}>
      {children}
    </div>
  );
}

export function CardHeader({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div className={cn('flex items-center justify-between mb-4', className)}>
      {children}
    </div>
  );
}

export function CardTitle({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <h3 className={cn('text-[14px] font-semibold text-hms-text', className)}>{children}</h3>
  );
}

export function CardDescription({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <p className={cn('text-[12px] text-hms-textDim', className)}>{children}</p>
  );
}
